import {
  DeprecatedDropdown,
  DeprecatedDropdownButton,
  DeprecatedDropdownItem,
  DeprecatedDropdownMenu,
} from "@deere/fuel-react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { ConfigContext } from "../../../../context/ConfigContext";
import { FeatureToggleContextV2 } from "../../../../context/FeatureToggleContextV2/FeatureToggleContextV2";
import {
  CATEGORIES,
  TOGGLES,
} from "../../../../pages/featureToggles/constants";

interface D2DMenuProps {
  selected?: boolean;
}

const D2DMenu = ({ selected = false }: D2DMenuProps) => {
  const theme = useTheme();
  const { t } = useTranslation("common");
  const { isToggleEnabled, additionalFieldsValues } = useContext(
    FeatureToggleContextV2
  );
  const { ENABLE_D2D } = useContext(ConfigContext);

  const isD2DEnabled =
    ENABLE_D2D && isToggleEnabled(CATEGORIES.D2D_SERVICE, TOGGLES.ENABLE_D2D);
  const d2dLinks =
    additionalFieldsValues(CATEGORIES.D2D_SERVICE, TOGGLES.ENABLE_D2D)?.get(
      "d2d_links"
    ) || [];

  const showMyLocatorEntry =
    isD2DEnabled && d2dLinks.includes("my_locator_entry");
  const showMyLocatorInventory =
    isD2DEnabled && d2dLinks.includes("my_locator_inventory");
  const showOtherDealerInventory =
    isD2DEnabled && d2dLinks.includes("other_dealer_inventory");
  const showD2DOrders = isD2DEnabled && d2dLinks.includes("d2d_orders");
  const showD2DRequests = isD2DEnabled && d2dLinks.includes("d2d_requests");
  const dropDownItemStyle = {
    borderWidth: "0px 0px 0px 3px",
    borderStyle: "solid",
    borderColor: "transparent",
  };

  const getUrl = (path: string) => path;

  const dropDownHoverStyle = {
    ".MenuItem-link:hover": {
      color: theme.tokens.FuelColorBrandPrimary,
      backgroundColor: theme.tokens.FuelColorAlertSuccessBackground,
      borderColor: `${theme.tokens.FuelColorAlertSuccessBorder} !important`,
    },
  };

  return (
    <DeprecatedDropdown>
      <DeprecatedDropdownButton
        variant="text"
        data-testid="d2d-drop-down"
        style={{
          padding: "20px 8px",
          color: theme.tokens.FuelColorGray600,
          borderRadius: "0px",
          ...(selected && {
            color: theme.tokens.FuelColorBrandPrimary,
            fontWeight: theme.tokens.FuelFontWeightSemibold,
            borderBottom: `3px solid ${theme.tokens.FuelColorBrandPrimary}`,
          }),
        }}
      >
        {t("header.navItem.d2d")}
      </DeprecatedDropdownButton>
      <DeprecatedDropdownMenu
        className="d2d-menu-dropdown"
        style={{ minWidth: "max-content" }}
      >
        <Box sx={dropDownHoverStyle}>
          {showMyLocatorEntry && (
            <Link
              to={getUrl("/my-locator-entry")}
              style={{ textDecoration: "none" }}
            >
              <DeprecatedDropdownItem
                style={dropDownItemStyle}
                data-testid="my-locator-entry"
              >
                {t("header.navItem.myLocatorEntry")}
              </DeprecatedDropdownItem>
            </Link>
          )}
          {showMyLocatorInventory && (
            <Link
              to={getUrl("/my-locator-inventory")}
              style={{ textDecoration: "none" }}
            >
              <DeprecatedDropdownItem
                style={dropDownItemStyle}
                data-testid="my-locator-inventory"
              >
                {t("header.navItem.myLocatorInventory")}
              </DeprecatedDropdownItem>
            </Link>
          )}
          {showOtherDealerInventory && (
            <Link
              to={getUrl("/other-dealer-inventory")}
              style={{ textDecoration: "none" }}
            >
              <DeprecatedDropdownItem
                style={dropDownItemStyle}
                data-testid="other-dealer-inventory"
              >
                {t("header.navItem.otherDealerInventory")}
              </DeprecatedDropdownItem>
            </Link>
          )}
          {showD2DOrders && (
            <Link
              to={getUrl("/d2d-orders-buy")}
              style={{ textDecoration: "none" }}
            >
              <DeprecatedDropdownItem
                style={dropDownItemStyle}
                data-testid="d2d-orders"
              >
                {t("header.navItem.d2dOrders")}
              </DeprecatedDropdownItem>
            </Link>
          )}
          {showD2DRequests && (
            <Link
              to={getUrl("/d2d-orders-sell")}
              style={{ textDecoration: "none" }}
            >
              <DeprecatedDropdownItem
                style={dropDownItemStyle}
                data-testid="d2d-requests"
              >
                {t("header.navItem.d2dRequests")}
              </DeprecatedDropdownItem>
            </Link>
          )}
        </Box>
      </DeprecatedDropdownMenu>
    </DeprecatedDropdown>
  );
};

export default D2DMenu;
